import _extends from '/app/node_modules/babel-runtime/helpers/extends';
import { settingsConfig } from '../../../config/settings';

var ROOT = {
	root: true
};

var contact = {
	fullname: null,
	email: null,
	phone: null
};

var developer = _extends({
	developmentType: '',
	company: null
}, contact);

var integration = {
	paymentForm: ''
};
var form = {
	idAffiliation: 0,
	step: 1,
	productType: null,
	productChoice: null,
	processInitDate: '',
	posSelected: {
		pos: '',
		id: null,
		priceSoles: '',
		priceDolares: '',
		TipoConexion: '',
		rental: {
			uniqueMoney: {
				soles: 0,
				dolares: 0
			},
			biMoney: {
				soles: 0,
				dolares: 0
			}
		},
		tarifas: {}
	},
	rucValidation: {
		ruc: null,
		businessName: '',
		consultDate: null
	},
	membershipType: {
		type: 'IND',
		startDate: null,
		endDate: null
	},
	legalRepresentativeData: {
		id: null,
		firstName: '',
		maternalName: '',
		paternalName: '',
		documentType: '',
		documentNumber: '',
		cellPhone: '',
		secondPhone: '',
		email: '',
		birthdate: '',
		consultDate: null
	},
	businessData: {
		adminCommerEquals: '',
		commerceData: {
			id: null,
			tradeName: '',
			email: '',
			commercialBusiness: null,
			nationalMcc: '',
			applyToPartnerPlan: ''
		},
		commercialAddress: {
			id: null,
			department: '',
			province: '',
			district: '',
			typeOfRoad: '',
			nameOfRoad: '',
			numberOfRoad: '',
			plusCode: '',
			km: '',
			block: '',
			allotment: '',
			interiorType: '',
			interior: '',
			reference: '',
			typeUrbanHabilitation: {},
			urbanHabilitation: '',
			cellPhone: '',
			prefix: '',
			landline: ''
		},
		administrativeAddress: {
			id: null,
			department: '',
			province: '',
			district: '',
			typeOfRoad: '',
			nameOfRoad: '',
			numberOfRoad: '',
			plusCode: '',
			km: '',
			block: '',
			allotment: '',
			interiorType: '',
			interior: '',
			reference: '',
			typeUrbanHabilitation: {},
			urbanHabilitation: '',
			cellPhone: '',
			prefix: '',
			landline: ''
		}
	},
	businessSchedule: {
		id: null,
		idSchedule: null,
		schedule: [],
		initDay: '',
		endDay: '',
		startTime: '',
		endTime: null
	},
	installationSchedule: {
		id: null,
		serviceHours: [],
		name: '',
		phone: '',
		paternalLastname: null,
		maternalLastname: null,
		email: null,
		documentType: null,
		documentNumber: null
	},
	paymentData: {
		currencyType: '',
		idSoles: null,
		bankNameSoles: '',
		accountTypeSoles: '',
		accountNumberSoles: '',
		alternativeAccountNumberSoles: '',
		idDolares: null,
		bankNameDolares: '',
		accountTypeDolares: '',
		accountNumberDolares: '',
		alternativeAccountNumberDolares: ''
	},
	membershipRequirements: {
		url: [],
		sapFiles: []
	},
	osvType: {
		osvType: '',
		commercialCode: ''
	},
	quotation: {
		posName: '',
		posNumber: '1',
		taxQuota: '01',
		installationCost: null,
		installationCostDolar: null,
		rentalPrice: 0.0,
		rentalPriceDolares: 0.0,
		stateShippingCost: 5.0,
		stateShippingCostDolar: 1.5,
		creditCardCommission: '4.5%',
		debitCardCommission: '3.8%'
	},
	afilliationSummary: {
		id: null,
		equiptment: '',
		dues: ''
	},
	ubigeo: '',
	num_incidencia: settingsConfig.num_incidencia,
	preliminaryCheckResult: {},
	commercialTariffResults: [],
	commerceCode: [{ code: null, text: '' }],
	affiliateResults: [],
	virtual: {
		user: {
			id: 0,
			usingLegalRepresentativeData: false,
			fullname: '',
			email: '',
			phone: ''
		},
		app: {
			id: 0,
			name: '',
			link: '',
			platform: '',
			developer: developer,
			integration: integration
		},
		webSite: {
			id: 0,
			url: '',
			developer: developer,
			integration: integration
		}
	},
	virtualComerceData: [],
	administrativePlatform: [],
	idTransaction: null,
	validateCrmClientData: null,
	registerStatus: null,
	onHold: null,
	multiAdress: [],
	dataTable: [],
	infoTable: {
		countInHold: 0,
		countNotWorked: 0,
		countWorked: 0
	}
};

export default form;


//////////////////
// WEBPACK FOOTER
// ./src/store/affiliations/utils.js
// module id = ./src/store/affiliations/utils.js
// module chunks = 34